export default __webpack_public_path__ + "static/media/video_wave.2860bafa.svg";